// import Cookies from 'js-cookie'

const TokenKey = 'dataCenter_token'

export function getLoginName() {
  return window.localStorage.getItem('dataCenter_loginname')
}

export function getToken() {
  return window.localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return window.localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  window.localStorage.removeItem(TokenKey)
}
